import React,{useState,useEffect } from 'react';
import { GET_STATE_URI,GET_LOCATION_TYPE} from '../../constant'; 
import {restrictZipInput} from "../../utils";
import axios from 'axios';

//import { InputNumber } from 'primereact/inputnumber';

const LocationContent = ({setLocationValue,passId,locType,errors,setErrors}) =>{

  const handleInputChange=(e)=>{
    const {name,value}=e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
    setLocationValue((prev)=>{
        return{
         ...prev,
          [name]:value,
          loc_type:locType,
          pass_id:passId
        }
    });
}

  const [stateData, setStateData] = useState([]);
  const [locationType, setLocationType] = useState([]);
  useEffect(() => {
      const loadUser = async ()=>{
        try {
          const response1 = await axios.get(GET_STATE_URI);
          const response2 = await axios.get(GET_LOCATION_TYPE);
          
          // Ensure we always set arrays
          setStateData(Array.isArray(response1.data) ? response1.data : []);
          setLocationType(Array.isArray(response2.data.data) ? response2.data.data : []);
          
          console.log("locationType response:",response2.data.data);
        } catch (error) {
          console.error("Error loading data:", error);
          setStateData([]);
          setLocationType([]);
        }
      }
    loadUser();

    const firstOption = document.querySelector('#loc_state');
    if (firstOption) {
      firstOption.style.fontWeight = 'bold';
    }
  }, []);

  return (
    <div className="form-items">
               <div className="form-floating mb-3">
               <select className="form-select require-field" id="location_type" aria-label="Location type select" onChange={handleInputChange} name="location_type">
                       <option value="">Select Location Type</option>
                      {
                        Array.isArray(locationType) && locationType.map((type, index)=>{
                          return <option key={index} value={type.location_type_code}>{type.location_type_name}</option>
                        })
                      }
                      
                  </select>
                  <label className='require-field' htmlFor="location_type">Location Type</label>
                  {errors.location_type && <span className="errors">{errors.location_type}</span>}
                </div>
               <div className="form-floating mb-3">
                  <input 
                  type="text" 
                  className="form-control" 
                  id="loc_name" 
                  name='loc_name' 
                  onChange={handleInputChange} 
                  placeholder="" 
                  autoComplete="off"
                  />
                  <label className='require-field' htmlFor="loc_name">Address 1</label>
                  {errors.loc_name && <span className="errors">{errors.loc_name}</span>}
                </div>
               <div className="form-floating mb-3">
                  <input 
                  type="text" 
                  className="form-control" 
                  id="loc_adress" 
                  name="loc_address" 
                  onChange={handleInputChange} 
                  placeholder="" 
                  autoComplete="off"
                  />
                  <label htmlFor="loc_adress">Address 2</label>
                  {errors.loc_address && <span className="errors">{errors.loc_address}</span>}
                </div>
                <div className="form-floating mb-3">
                  <input 
                  type="text" 
                  className="form-control" 
                  id="loc_city" 
                  onChange={handleInputChange} 
                  name="loc_city" 
                  placeholder=""  
                  autoComplete="off"
                  />
                  <label className='require-field' htmlFor="loc_city">City</label>
                  {errors.loc_city && <span className="errors">{errors.loc_city}</span>}
                </div>
               <div className="form-floating mb-3">
               
               <select className="form-select require-field bold-option" id="loc_state" aria-label="Default select example" onChange={handleInputChange} name="loc_state">
                       <option value="" className='bold-option'><strong>Select State</strong></option>
                      {Array.isArray(stateData) && stateData.map((state, index) => (
                         <option key={index} value={state.state_id}>{state.state_name}</option>
                       ))}
                  </select>
                  {errors.loc_state && <span className="errors">{errors.loc_state}</span>}
                </div>
                
               <div className="form-floating mb-3">
                  <input 
                  type="number" 
                  onInput={restrictZipInput} 
                  className="form-control" 
                  id="loc_zip" 
                  onChange={handleInputChange} 
                  name="loc_zip"  
                  placeholder="" 
                  autoComplete="off"
                  />
                  <label className='require-field' htmlFor="loc_zip">Zip</label>
                  {errors.loc_zip && <span className="errors">{errors.loc_zip}</span>}
                </div>
                
               </div>
  )
}

export default LocationContent